import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["title"]

import BaseIcon from '../../legacy/ui/base-icon/icon.vue';

type Props = {
  element?: 'div' | 'a';
  title?: string;
  description?: string;
  showCheckbox?: boolean;
  icon?: string;
  hovered?: boolean;
  selected?: boolean;

  disabled?: boolean;
  multiline?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'base-select-item',
  props: {
    element: { default: 'div' },
    title: {},
    description: {},
    showCheckbox: { type: Boolean, default: true },
    icon: {},
    hovered: { type: Boolean },
    selected: { type: Boolean },
    disabled: { type: Boolean },
    multiline: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.element), {
    role: "option",
    title: __props.title,
    class: _normalizeClass([
      _ctx.$style.item, {
        [_ctx.$style.hovered]: __props.hovered,
        [_ctx.$style.disabled]: __props.disabled,
        [_ctx.$style.multiline]: __props.multiline
      }
    ])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.visuals)
      }, [
        (__props.showCheckbox)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.checkbox)
            }, [
              _renderSlot(_ctx.$slots, "checkbox", {}, () => [
                (__props.selected)
                  ? (_openBlock(), _createBlock(BaseIcon, {
                      key: 0,
                      type: "checked-item-mark-new"
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "icon", {}, () => [
          (__props.icon)
            ? (_openBlock(), _createBlock(BaseIcon, {
                key: 0,
                type: __props.icon
              }, null, 8, ["type"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _renderSlot(_ctx.$slots, "title", { title: __props.title }, () => [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.title),
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createTextVNode(_toDisplayString(__props.title) + " ", 1),
          _renderSlot(_ctx.$slots, "title-hint")
        ], 34)
      ]),
      (__props.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style.description),
            title: __props.description
          }, _toDisplayString(__props.description), 11, _hoisted_1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "after-content")
    ]),
    _: 3
  }, 8, ["title", "class"]))
}
}

})